// src/pages/Dashboard/components/Header/DashboardHeader.js

import React from 'react';
import './DashboardHeader.css';

/**
 * Header do Dashboard com menu sanduiche e botão de voltar
 * @param {function} onToggleSidebar - Callback para abrir/fechar sidebar
 * @param {function} onBackToSystem - Callback para voltar ao sistema
 * @param {boolean} debugMode - Estado do modo debug
 * @param {function} onToggleDebug - Callback para alternar modo debug
 */
const DashboardHeader = ({ 
  onToggleSidebar, 
  onBackToSystem, 
  debugMode = false, 
  onToggleDebug 
}) => {
  return (
    <div className="dashboard-header">
      <div className="dashboard-header-left">
        <button 
          className="menu-sanduiche" 
          onClick={onToggleSidebar}
          title="Abrir menu de casos"
        >
          ☰
        </button>
        <h2>Dashboard de Casos</h2>
        {onToggleDebug && (
          <button 
            className={`btn-debug ${debugMode ? 'active' : ''}`}
            onClick={onToggleDebug}
            title="Alternar modo debug"
          >
            {debugMode ? 'DEBUG ON' : 'DEBUG OFF'}
          </button>
        )}
      </div>
      <button 
        className="btn-back-system" 
        onClick={onBackToSystem} 
        title="Voltar ao Sistema"
      >
        ←
      </button>
    </div>
  );
};

export default DashboardHeader;